import type { FileWithPath } from '@mantine/dropzone';

export const readCsvImportFile = (file: FileWithPath) => {
  const reader = new FileReader();

  return new Promise<string>((resolve, reject) => {
    reader.onload = () => {
      resolve(reader.result as string);
    };
    // Normalize FileReader failures so callers receive a useful error message.
    reader.onerror = () => {
      reject(reader.error ?? new Error('Failed to read CSV file.'));
    };
    reader.onabort = () => {
      reject(new Error('CSV file read was aborted.'));
    };
    reader.readAsText(file);
  });
};

export const getCsvImportTeamScopeBlockReason = ({
  isTeamIdFetching,
  isTeamSwitching,
}: {
  isTeamIdFetching: boolean;
  isTeamSwitching: boolean;
}) => {
  if (!isTeamIdFetching && !isTeamSwitching) return null;

  return 'Team access is still loading. Wait a moment and retry the import.';
};
